import { Card } from "@material-ui/core";
import { Container } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AppHeader from "@saleor/components/AppHeader";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { maybe } from "@saleor/misc";
import { FilterPageProps, ListProps, TabPageProps } from "@saleor/types";
import { PermissionEnum } from "@saleor/types/globalTypes";
import React from "react";
import { useIntl } from "react-intl";

import { hasPayoutPerm } from "../../PayoutPermissions";
import { PayoutStoreOrders_payoutStoreOrders_edges_node } from "../../types/PayoutStoreOrders";
import PayoutReviewButton from "../PayoutReviewButton";
import PayoutsDetailsList from "../PayoutsDetailsList";
import {
  createFilterStructure,
  PayoutsDetailPageFilterKeys,
  PayoutsDetailsPageFilterOpts
} from "./filters";
interface PayoutsDetailsPageProp
  extends ListProps,
    FilterPageProps<PayoutsDetailPageFilterKeys, PayoutsDetailsPageFilterOpts>,
    TabPageProps {
  id: string;
  payouts: PayoutStoreOrders_payoutStoreOrders_edges_node[];
  user: any;
  onDownloadName: string;
  payoutStatus: string;
  onBack: () => void;
  download: () => void;
  onSettlementEdit: (id: string) => void;
  onPayable: (id: string) => void;
  onReview: (updateTo: string) => void;
  onManagerDownload?: () => void;
}

const PayoutsDetailsPage: React.FC<PayoutsDetailsPageProp> = ({
  currentTab,
  filterOpts,
  id,
  initialSearch,
  onDownloadName,
  onSearchChange,
  onFilterChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  download,
  user,
  tabs,
  currencySymbol,
  onBack,
  onReview,
  payouts,
  payoutStatus,
  onManagerDownload,
  ...listProps
}) => {
  const intl = useIntl();

  const perm = [
    PermissionEnum.MANAGE_PAYOUT_PAYMENT,
    PermissionEnum.MANAGE_PAYOUT_PAYABLES
  ];
  const isTreasury = hasPayoutPerm(perm, user.userPermissions);
  const structure = createFilterStructure(intl, filterOpts, isTreasury);
  const isManager = hasPayoutPerm(
    [PermissionEnum.MANAGE_PAYOUT_ON_PROCESS],
    user.userPermissions
  );

  return (
    <>
      <Container maxWidth="xl">
        <AppHeader onBack={onBack}>
          {intl.formatMessage({
            defaultMessage: "Payout",
            description: "Payout page"
          })}
        </AppHeader>
        <PageHeader
          title={intl.formatMessage(
            {
              defaultMessage: "Payout ID {value}",
              description: "Payout id"
            },
            {
              value: atob(id)
            }
          )}
        >
          <PayoutReviewButton
            payoutStatus={payoutStatus}
            onReview={onReview}
            user={user}
          />
          <Button
            color="primary"
            variant="contained"
            disabled={!payouts}
            onClick={download}
          >
            {maybe(() => onDownloadName, "Download")}
          </Button>
          {isManager && user.lastName === "Manager" && (
            <Button
              style={{ marginLeft: "15px" }}
              color="primary"
              variant="contained"
              disabled={!payouts}
              onClick={onManagerDownload}
            >
              DOWNLOAD
            </Button>
          )}
        </PageHeader>
        <Card>
          <FilterBar
            allTabLabel={atob(id)}
            currencySymbol={currencySymbol}
            currentTab={currentTab}
            tabs={tabs}
            filterStructure={structure}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Order Code"
            })}
            initialSearch={initialSearch}
            onSearchChange={onSearchChange}
            onFilterChange={onFilterChange}
            onAll={onAll}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <PayoutsDetailsList
            {...listProps}
            user={user}
            payouts={payouts}
            payoutStatus={payoutStatus}
          />
        </Card>
      </Container>
    </>
  );
};

export default PayoutsDetailsPage;
